import type { ModuleNav } from '@saas/ui';

/**
 * conversation のメニュー（§12.10.2 第 3 優先）。「仕事の会話」= 未読のあるレコード会話の一覧ページ。
 * サイドバーに全レコード会話を展開しない。badge 'conversation.unread' はシェルが GET /conversation/me の
 * unreadRecordConversations.length を counts に載せたときに出る（載せなければ数字なし）。
 * DM・チャンネルの常設メニューは段 4 の chat
 */
export const conversationNav: ModuleNav = {
  module: 'conversation',
  items: [{ label: '仕事の会話', to: '/conversation', icon: 'chat_bubble', permission: ['conversation.message.read'], badge: 'conversation.unread', description: '未読のあるレコード会話' }],
  admin: [],
};
